/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { organizationAssetsUploadImage } from "../funcs/organizationAssetsUploadImage.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { UploadImageResult } from "../models/components/uploadimageresult.js";
import {
  UploadOrganizationImageRequest,
  UploadOrganizationImageSecurity,
} from "../models/operations/uploadorganizationimage.js";
import { unwrapAsync } from "../types/fp.js";

export class OrganizationAssets extends ClientSDK {
  /**
   * uploadOrganizationImage organizationAssets
   *
   * @remarks
   * Upload an organization-tier image (e.g. a remote identity provider logo). Requires org:admin.
   */
  async uploadImage(
    request: UploadOrganizationImageRequest,
    security?: UploadOrganizationImageSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UploadImageResult> {
    return unwrapAsync(organizationAssetsUploadImage(
      this,
      request,
      security,
      options,
    ));
  }
}
